import React, { Fragment } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";

const DefaultModalMessage = props => {
  const close =
    props && props.actions && `function` === typeof props.actions.close
      ? props.actions.close
      : () => undefined;

  return (
    <Fragment>
      <DialogTitle>Default Message</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Someone triggered a modal without specifiying a message. Not cool.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>@$#&amp;^%!!</Button>
      </DialogActions>
    </Fragment>
  );
};

export default DefaultModalMessage;
